import axios from "~/plugins/axios";

export default {
  getByCustomerId(customerId) {
    return axios.get(`/web_api/v1/damage/by_customer/${customerId}`).then((response) => response.data);
  },

  getById(damageId, includes) {
    return axios.get(`/web_api/v1/damage/${damageId}`, { params: { include: includes } }).then((response) => response.data);
  },
};
